var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4009 0H3.84508C1.79297 0 0 1.47656 0 3.50458V41.1439C0 43.1829 1.79297 45 3.84508 45H41.3899C43.4531 45 44.9999 43.1709 44.9999 41.1439V3.50458C45.012 1.47656 43.4531 0 41.4009 0ZM13.949 37.5097H7.50233V17.4656H13.949V37.5097ZM10.9486 14.4181H10.9024C8.83927 14.4181 7.50334 12.8823 7.50334 10.9597C7.50334 9.00201 8.87443 7.50234 10.9838 7.50234C13.0932 7.50234 14.3839 8.99096 14.4301 10.9597C14.4291 12.8823 13.0932 14.4181 10.9486 14.4181ZM37.5097 37.5097H31.063V26.55C31.063 23.9243 30.1248 22.1304 27.7925 22.1304C26.0106 22.1304 24.9559 23.3357 24.4868 24.5099C24.311 24.9318 24.2638 25.5064 24.2638 26.093V37.5097H17.8172V17.4656H24.2638V20.255C25.202 18.9191 26.6675 16.9965 30.0776 16.9965C34.3094 16.9965 37.5107 19.7859 37.5107 25.7997L37.5097 37.5097Z",
    fill: "#0961B8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1f54e49a6dd9c683fd47bffb0b307c95.svg";
export { ForwardRef as ReactComponent };